import { css } from "styled-components";
import { CART_INK, FEE, SAVINGS } from "./savings";

/**
 * The total tinting as it rolls — green when it drops, amber when it climbs.
 *
 * One fragment, interpolated by both surfaces that show a total: the cart and
 * the sticky bar. It used to be two copies of the same keyframes under two
 * names, and the copy on the bar had the three colours inlined as hex — on the
 * one surface a visitor below 992px actually sees. `savings.ts` exists so that
 * "green means costs less" is decided once.
 *
 * Paired with `useRollingTotal`, which owns the matching `TINT_MS`.
 */
export const rollingTotalTint = css`
  @keyframes cart-total-down {
    0%,
    55% {
      color: ${SAVINGS.ink};
    }
    100% {
      color: ${CART_INK};
    }
  }
  @keyframes cart-total-up {
    0%,
    55% {
      color: ${FEE.ink};
    }
    100% {
      color: ${CART_INK};
    }
  }

  .rolling-down {
    animation: cart-total-down 900ms ease-out both;
  }
  .rolling-up {
    animation: cart-total-up 900ms ease-out both;
  }

  @media (prefers-reduced-motion: reduce) {
    .rolling-down,
    .rolling-up {
      animation: none;
    }
  }
`;
